export const validateIddConfiguration = (mockIdd: boolean, documentDownload: boolean, iddBackendHost?: string) => {
  if (!mockIdd && !documentDownload && !iddBackendHost) {
    console.warn("Warning! iddBackendHost prop is missing from checkout configuration!");
  }
}